module.exports = __webpack_public_path__ + "static/media/paypalicon.7954be9d.svg";